import styled from "@emotion/styled"
import ReactPlayer from "react-player"
styled
const Styled = {
  PlayerWrapper: styled.div`
    height: 200px;
    margin-top: 0px;
    position: relative;
    width: 100%;
  `,
  ReactPlayer: styled(ReactPlayer)`
    margin: 0 auto;
    max-width: 100%;
    position: relative;
    width: 100% !important;
    height: 200px !important;
    border-radius: 16px;
    iframe {
      border-radius: 16px;
    }
  `,
}

interface YouTubePlayerProps {
  url: string
  width?: string | number
  height?: string | number
  playing?: boolean
  noMargin?: boolean
  setAbsolute?: boolean
}

export default function YouTubePlayer(props: YouTubePlayerProps) {
  return (
    <Styled.PlayerWrapper>
      <Styled.ReactPlayer
        url={props.url}
        width={props.width}
        height={props.height}
        playing={props.playing}
      />
    </Styled.PlayerWrapper>
  )
}
